(() => {
  if (!window.Giesen?.routes || !window.GiesenCartQueue) return;
  const routes = window.Giesen.routes;
  const queue = new window.GiesenCartQueue();
  let busy = false;
  let opener = null;
  const drawer = () => document.getElementById('GiesenCartDrawer');
  const open = (trigger = document.activeElement) => {
    const dialog = drawer();
    if (!dialog || !dialog.showModal) { window.location.assign(routes.cart); return; }
    opener = trigger;
    if (!dialog.open) dialog.showModal();
    dialog.querySelector('[data-cart-close]')?.focus();
  };
  const close = () => { drawer()?.close(); opener?.focus(); };
  const sections = () => [...document.querySelectorAll('[data-cart-section]')].map(el => el.dataset.cartSection);
  const captureFocus = element => ({
    element,
    section: element?.closest?.('[data-cart-section]')?.dataset.cartSection,
    key: element?.dataset?.key,
    name: element?.name,
    id: element?.id
  });
  const restoreFocus = focus => {
    if (!focus) return;
    const section = [...document.querySelectorAll('[data-cart-section]')].find(el => el.dataset.cartSection === focus.section);
    const keyed = focus.key && [...(section?.querySelectorAll('[data-key]') || [])].find(el => el.dataset.key === focus.key && el.name === focus.name);
    const named = focus.name && [...(section?.querySelectorAll('button[name]') || [])].find(el => el.name === focus.name);
    const target = keyed || named || (focus.element?.isConnected && focus.element) || (!section && focus.id && document.getElementById(focus.id)) || section?.querySelector('button, a');
    target?.focus();
  };
  const replace = (htmlSections) => {
    for (const id of sections()) {
      const html = htmlSections?.[id];
      if (!html) throw new Error('Your cart changed, but its display could not be refreshed. Open your cart to review it.');
      const parsed = new DOMParser().parseFromString(html, 'text/html');
      const next = [...parsed.querySelectorAll('[data-cart-section]')].find(el => el.dataset.cartSection === id);
      const current = [...document.querySelectorAll('[data-cart-section]')].find(el => el.dataset.cartSection === id);
      if (!next || !current) throw new Error('Open your cart to review the latest changes.');
      current.replaceWith(next);
    }
    const count = document.querySelector('[data-cart-item-count]')?.dataset.cartItemCount;
    if (count !== undefined) document.querySelectorAll('[data-cart-count]').forEach(el => { el.textContent = count; });
    document.querySelectorAll('[data-cart-status]').forEach(el => { el.textContent = 'Cart updated.'; });
  };
  const mutate = (route, body, focus = captureFocus(document.activeElement)) => queue.run(async () => {
    busy = true;
    const controls = [...document.querySelectorAll('[data-cart-form] button, [data-cart-form] input')];
    const enabled = controls.filter(el => !el.disabled);
    enabled.forEach(el => { el.disabled = true; });
    try {
      const ids = sections();
      if (body instanceof FormData) { body.set('sections', ids.join(',')); body.set('sections_url', window.location.pathname); }
      else body = {...body, sections: ids, sections_url: window.location.pathname};
      const response = await fetch(route + '.js', {method:'POST', headers: body instanceof FormData ? {'Accept':'application/json'} : {'Content-Type':'application/json','Accept':'application/json'}, body: body instanceof FormData ? body : JSON.stringify(body)});
      let result;
      try { result = await response.json(); } catch { throw new Error('We could not confirm the cart change. Review your cart before trying again.'); }
      if (!response.ok) throw new Error(result.description || result.message || 'The cart could not be updated.');
      replace(result.sections);
      return result;
    } finally { busy = false; enabled.forEach(el => { el.disabled = false; }); restoreFocus(focus); }
  });
  const showError = error => {
    document.querySelectorAll('[data-cart-error]').forEach(el => {
      el.hidden = false; el.textContent = error.message || 'We could not confirm your change. Review your cart before trying again.';
      const link = document.createElement('a'); link.href = routes.cart; link.textContent = ' Review cart'; el.append(link);
    });
  };
  document.addEventListener('click', event => {
    const target = event.target.closest('[data-cart-open], [data-cart-close], [data-cart-remove]');
    if (!target) return;
    if (target.matches('[data-cart-open]')) { if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return; event.preventDefault(); open(target); }
    else if (target.matches('[data-cart-close]')) { event.preventDefault(); close(); }
    else { event.preventDefault(); if (busy) return; mutate(routes.cartChange, {id:target.dataset.key, quantity:0}, captureFocus(target)).catch(showError); }
  });
  document.addEventListener('submit', event => {
    const form = event.target.closest('[data-cart-form]');
    if (!form) return;
    if (event.submitter?.name === 'checkout') { if (busy) event.preventDefault(); return; }
    if (busy) { event.preventDefault(); return; }
    const changes = [...form.querySelectorAll('[data-cart-quantity]')].filter(input => Number(input.value) !== Number(input.defaultValue));
    // Multiple changes submit natively: an earlier change can regenerate line keys.
    if (changes.length > 1) return;
    event.preventDefault();
    if (!changes.length) return;
    const input = changes[0];
    mutate(routes.cartChange, {id:input.dataset.key, quantity:Number(input.value)}, captureFocus(event.submitter || document.activeElement)).catch(showError);
  });
  drawer()?.addEventListener('close', () => opener?.focus());
  drawer()?.addEventListener('click', event => { if (event.target === drawer()) close(); });
  window.Giesen.cart = {mutate, open};
})();
